import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import constants from '../../../../constants';
import { Creators as procedureActions } from '@/domain/useCases/procedures/getProcedureInformation';
import { Creators as procedureStatusActions } from '@/domain/useCases/procedures/getStudentProcedureStatus';
import RetreatCourseInfoView from './RetreatCourseInfoView';
import routes from '@/presentation/components/Routes/routingMap';
import useExternalSettings from '@/presentation/hooks/useExternalSettings';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';

const RetreatCourseViewController = () => {
  const history = useHistory();
  const params: any = useParams();
  const dispatch = useDispatch();
  const [showNotAvailableModal, setShowNotAvailableModal] = useState(false);
  const [showProcedureExists, setShowProcedureExists] = useState(false);
  const [showNotEnrollment, setShowNotEnrollment] = useState(false);
  const [showNotScholaShip, setShowNotScholaShip] = useState(false);
  const [showNotCourses, setShowNotCourses] = useState(false);

  const {
    procedure: procedureSelectedInfo,
    isLoading,
    selectedProcedureId
  } = useSelector((state: any) => state.procedureInformation);

  const { procedureWhiteList } = useExternalSettings();

  useEffect(() => {
    GoogleAnalytics.writeLog(`portal-procedure-retreatCourse`, 'portal');
    if (!isLoading && !procedureSelectedInfo) {
      const selectedRequest: any =
        constants.categories.requests.procedureList.find(
          (p: any) => p.url === params.retreatCourse
        );
      dispatch(
        procedureActions.getProcedureInformation(
          selectedRequest?.procedureId ||
            constants.categories.requests.procedures.retreatCourse
        )
      );
    }
  }, []);

  const handleExistRequest = () => {
    if (procedureSelectedInfo?.disabled) {
      setShowNotAvailableModal(true);
      return;
    }
    if (procedureSelectedInfo?.requestInProgress) {
      setShowProcedureExists(true);
      return;
    }
    if (procedureSelectedInfo?.enrollment === false) {
      setShowNotEnrollment(true);
      return;
    }
    if (procedureSelectedInfo?.detail.hasScholarship === true) {
      setShowNotScholaShip(true);
      return;
    }
    if (
      procedureSelectedInfo?.detail.enrolledCourses.length +
        procedureSelectedInfo?.detail.relatedCourses.length <=
        1 &&
      !procedureSelectedInfo.hasFinishedCourses
    ) {
      setShowNotCourses(true);
      return;
    }
    history.push(
      routes.student.procedures.categories.requests.retreatCourse.register
    );
  };
  const handlerBackButton = () => {
    history.goBack();
  };
  const handlerRetreatPeriod = () => {
    history.push(
      `/tramites/ticketera/registro?v=${
        procedureSelectedInfo?.detail.hasScholarship === true
          ? 'TA0050'
          : 'TA0052'
      }`
    );
  };
  const url = '/tramites/ticketera/registro?v=TA0050';
  const handlerTicket = () => {
    history.push('/tramites/ticketera/registro');
  };

  const handlerGoToExistingProcedure = () => {
    dispatch(
      procedureStatusActions.getStudentProcedureStatus(
        1036,
        procedureSelectedInfo.currentRequestId
      )
    );
    history.push(
      routes.student.procedures.categories.requests.retreatCourse.progress
    );
  };

  if (
    selectedProcedureId !== undefined &&
    procedureWhiteList?.length > 0 &&
    !procedureWhiteList?.includes(selectedProcedureId?.toString())
  ) {
    history.push(routes.student.procedures.home);
  }

  return (
    <RetreatCourseInfoView
      procedureSelectedInfo={procedureSelectedInfo}
      NotAvailable={{
        showNotAvailableModal,
        setShowNotAvailableModal
      }}
      ProcedureExists={{
        showProcedureExists,
        setShowProcedureExists
      }}
      Enrollment={{
        showNotEnrollment,
        setShowNotEnrollment
      }}
      NotScholaShip={{
        showNotScholaShip,
        setShowNotScholaShip
      }}
      NotCourses={{
        showNotCourses,
        setShowNotCourses
      }}
      handlerTicket={handlerTicket}
      handlerRetreatPeriod={handlerRetreatPeriod}
      handleExistRequest={handleExistRequest}
      handlerBackButton={handlerBackButton}
      url={url}
      handlerGoToExistingProcedure={handlerGoToExistingProcedure}
    />
  );
};

export default RetreatCourseViewController;
